// @flow
import gql from 'graphql-tag';

type TravelerSearch = {
    namespace: 'traveler/search',
    category: 'messages'
};

type TravelerListing = {
    namespace: 'traveler/listing',
    category: 'messages'
};

type TravelerPropertyCarousel = {
    namespace: 'traveler/react-property-carousel',
    category: 'messages'
};

type StabFeedback = {
    namespace: 'ui-development/shared',
    category: 'stabFeedback'
};

type GXGlobalization = {
    namespace: 'gx/globalization',
    category: 'rebrandingBrandTransition'
};

type DiscoveryXplorer = {
    namespace: 'discovery/xplorer',
    category: 'messages'
};

type GlobalMessaging = {
    namespace: 'ui-development/shared',
    category: 'globalMessaging'
};

export type Bundle =
    | TravelerSearch
    | TravelerListing
    | StabFeedback
    | GXGlobalization
    | DiscoveryXplorer
    | GlobalMessaging
    | TravelerPropertyCarousel
    | {namespace: string, category: string};

const translationsQuery = gql`
    query LinguaQuery($locale: String, $bundle: Bundle!) {
        translations(locale: $locale, bundle: $bundle) {
            locale
            messages
        }
    }
`;

export default translationsQuery;
